import { api } from 'app/api';
import { selectSelectedEnvId } from 'app/containers/HiikoEnv/slice/selectors';
import { mapResourcesToOptionsGroupedByResourceType } from 'app/containers/Task/slice/helpers';
import {
  ITaskAvailableResource,
  ITaskAvailableResourceOption,
} from 'app/containers/Task/slice/types';
import { useSelector } from 'react-redux';

const useGetTaskResourceOptions = (): {
  options: ITaskAvailableResourceOption[];
  allResources: ITaskAvailableResource[];
} => {
  const envId = useSelector(selectSelectedEnvId) as number;

  const {
    data: resourceTypes,
  } = api.endpoints.getAllResourceTypes.useQueryState();

  const { data: allResources } = api.endpoints.getAllResources.useQueryState({
    envId,
  });

  let options: ITaskAvailableResourceOption[] = [];
  if (resourceTypes && allResources) {
    const resources = resourceTypes.map(resourceType => {
      const resources = allResources.filter(
        item => item.type.id === resourceType.id,
      );
      return resources;
    });
    options = mapResourcesToOptionsGroupedByResourceType({
      resourceTypes,
      resources,
    });
  }

  return {
    options,
    allResources: allResources ?? [],
  };
};

export default useGetTaskResourceOptions;
